'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useKeenSlider } from 'keen-slider/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Movie } from '@/types/movies';
import IconAdaptive from '@/components/IconAdaptive';
import SectionDecoratedTitle from '@/components/SectionDecoratedTitle';
import 'keen-slider/keen-slider.min.css';

export interface TopVideoGalleryProps {
    movies: Movie[];
}
const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

export default function TopVideoGallery({ movies }: TopVideoGalleryProps) {
    const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
        loop: true,
        slides: {
            perView: 'auto',
            spacing: 16,
        },
        renderMode: 'performance',
    });

    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
    useEffect(() => {
        if (movies && movies.length > 0) {
            const randomIndex = Math.floor(Math.random() * movies.length);
            setSelectedVideo(movies[randomIndex].url);
        }
    }, [movies]);

    return (
        <div className="flex flex-col justify-center items-center w-full pt-8 px-0 md:px-8">
            <div className="flex justify-center items-start w-full md:w-[98%] rounded-none md:rounded-3xl bg-color-white-base pt-8 px-8 pb-16">
                <div className="w-full md:w-[98%] lg:w-[85%] rounded-3xl">
                    <div className="w-full pb-12">
                        <SectionDecoratedTitle title="MOVIE" subTitle="スクーミーを動画で紹介" />
                    </div>
                    {selectedVideo && (
                        <div className="mb-8 aspect-video w-full">
                            <ReactPlayer url={selectedVideo} width="100%" height="100%" controls />
                        </div>
                    )}
                    <div className="relative overflow-hidden">
                        {movies.length > 0 && (
                            <div ref={sliderRef} className="keen-slider">
                                {movies.map((movie, idx) => (
                                    <div
                                        key={idx}
                                        className="keen-slider__slide relative aspect-video min-w-[80%] md:min-w-[45%] lg:min-w-[45%] xl:min-w-[30%]"
                                    >
                                        <ReactPlayer url={movie.url} width="100%" height="100%" controls />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="relative flex justify-between mt-2">
                        <button onClick={() => slider.current?.prev()}>
                            <IconAdaptive
                                Icon={ChevronLeft}
                                baseSize={30}
                                breakpoints={{ md: 30 }}
                                className="text-color-base"
                            />
                        </button>
                        <button onClick={() => slider.current?.next()}>
                            <IconAdaptive
                                Icon={ChevronRight}
                                baseSize={30}
                                breakpoints={{ md: 30 }}
                                className="text-color-base"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
